export const PRODUCT_LIST_TYPES = {
  EXH_01: 'list3', // 리스트형
  EXH_02: 'list3', // 리스트_판매알림형
  EXH_03: 'list2', // 1단형
  EXH_04: 'list1', // 2단형
  EXH_05: 'card2', // 가로 스와이프형
  EXH_06: 'card2', // 가로 스와이프형 소형
  EXH_07: 'card2', // 상품 6개 조합형
  EXH_08: 'card1', // 랭킹_리스트형
  EXH_09: 'card2', // 랭킹_스와이프형
  EXH_10: 'card1', // 상품 리뷰형
  EXH_12: 'list3', // 기획전 목록형
  EXH_13: 'card2', // 2행 가로스와이프 상품형
  EXH_14: 'card2', // 가로 스와이프형 소형 - 랭킹형
  EXH_15: 'card2', // 세로 긴 가로스와이프형
  EXH_16: 'card2', // 상품 6개 조합형 - AI추천
  EXH_17: 'card2', // 가로 스와이프형 소형 - 연관상품형
  EXH_htmlProduct: 'card1',

  CARD_GRID_5: 'card1',
  CARD_GRID_6: 'card2',
  CARD_GRID_10: 'card3',
  CARD_GRID_12: 'card5',
  CARD_SINGLE: 'card6',
  CARD_GRID_4: 'card4',
  LIST_GRID_1: 'list2',
  LIST_GRID_2: 'list1',
  LIST_GRID_3: 'list5',
  LIST_BASIC: 'list3',
  LIST_SMALL: 'list4'
}
